import React, { useMemo } from 'react';
import { Box, Button, DialogContent, DialogContentText } from '@mui/material';
import { useDispatch } from 'react-redux';
import CustomDialog from './CustomDialogue';
import useErrorSelector from '../store/Slice/Error/ErrorSelector';
import { resetErrorSlice } from '../store/Actions';

function CustomeErrorMessage({
  onClose, // parent handles closing
  actions // optional extra buttons
}) {
  const dispatch = useDispatch();
  const { ErrorStatus } = useErrorSelector(); // suppose this returns { open: true, message: "error msg" }

  const message = useMemo(() => ErrorStatus?.message || 'Something Went Wrong'[ErrorStatus]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(resetErrorSlice());
    }
  };

  return (
    <Box>
      <CustomDialog
        fullWidth={false}
        open={ErrorStatus?.open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleClose();
          }
        }}
        content={
          <DialogContent sx={{ p: 0 }}>
            <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
          </DialogContent>
        }
        actions={
          <>
            <Button onClick={handleClose}>Close</Button>
            {actions}
          </>
        }
      />
    </Box>
  );
}

export default CustomeErrorMessage;
